import React from 'react';
import PropTypes from 'prop-types';
import { StyledTabGroup, StyledTabGroupHeader } from './StyledComponents';

const Group = ({ title, children }) => {
  return (
    <StyledTabGroup>
      <StyledTabGroupHeader>{title}</StyledTabGroupHeader>
      {children}
    </StyledTabGroup>
  );
};

Group.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default Group;
